import React from "react";
import TableHeader from "./tableHeader";
import TableBody from "./tableBody";

const Table = ({
  columns,
  sortColumn,
  onSort,
  data,
  addCheckbox,
  updateColumnList,
  // Filter props
  filterState,
  onFilterChange,
  defaultFilterOptions,
  allData, // Full dataset for filter option generation (optional)
  financialProfessionals, // FP list for advisor column filter
  // External filter trigger props
  externalOpenFilter,
  onExternalFilterOpened,
}) => {
  return (
    <div className="clients-table-wrapper">
      <table className="table table-sm table-excel">
        <TableHeader
          columns={columns}
          sortColumn={sortColumn}
          onSort={onSort}
          updateColumnList={updateColumnList}
          // Filter props - use allData for options if provided, otherwise data
          data={allData || data}
          filterState={filterState}
          onFilterChange={onFilterChange}
          defaultFilterOptions={defaultFilterOptions}
          financialProfessionals={financialProfessionals}
          externalOpenFilter={externalOpenFilter}
          onExternalFilterOpened={onExternalFilterOpened}
        />
        <TableBody columns={columns} data={data} addCheckbox={addCheckbox} />
      </table>
    </div>
  );
};

export default Table;
